import * as React from 'react';
import { compose, Dispatch, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { UserRead, CompetitionUser, Competition, Entity, CompetitionUserScore, CompetitionScoreLevel } from '../../userApi';
import { State } from '../../redux/state';
import * as selectors from '../../redux/selectors';
import actions from '../../redux/actions';
import { LProps, withLocalization } from '../../utils/wrappers';
import UserHeader from '../../shared/UserHeader';
import UserStats from '../../shared/UserStats';
import Scoreboard from '../../shared/Scoreboard';
import Stories from '../../shared/Stories';
import PledgeCarousel from '../../shared/PledgeCarousel';
import Footer from '../../shared/Footer';
import EarnMorePoints from './EarnMorePoints';
import { asPage } from '../../utils/wrappers/asPage';
import { getCompetitionUserScore } from '../../utils/userApiHelper';
{/*import CampusRanks from './CampusRanks'; Get rid of Campus Ranking on dashboard.*/}

interface Props {
  user: UserRead;
  competitionUser: CompetitionUser;
  competition: Competition;
  hasEmailPermittedByCompetition: boolean;
  university: Entity;
  healthFacility: Entity;
  team: Entity;
  score: CompetitionUserScore;
  userUniversityRank: number;
  pledgeCompletions: number;
  scoreLevel: CompetitionScoreLevel;
  nextScoreLevel: CompetitionScoreLevel;
  reinitializeDashboardIfNecessary: () => void;
  hideFootprintFromProfile: () => void;
  showFootprintOnProfile: () => void;
}

interface DashboardState {
  mobileSection: number;
}
enum MobileSection {
  ACCOUNT = 1,
  STORIES = 2,
  STATS = 4
}

const initialState: DashboardState = {
  mobileSection: MobileSection.STORIES
};

class Dashboard extends React.Component<LProps<Props>, DashboardState> {
  public state = initialState;

  public componentWillMount() {
    const { reinitializeDashboardIfNecessary } = this.props;
    reinitializeDashboardIfNecessary();
    this.openInviteSectionIfRequested();
  }

  public componentDidMount() {
    this.openInviteSectionIfRequested();
  }

  private openInviteSectionIfRequested() {
    if (typeof window === 'undefined') return;
    if (window.location.hash === '#invite-friend') {
      this.setState({ mobileSection: MobileSection.ACCOUNT }, () => {
        const el = document.getElementById('invite-friend');
        if (el && typeof el.scrollIntoView === 'function') {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }
  }

  public render() {
    const {
      user, competitionUser, university, healthFacility, team, score,
      pledgeCompletions, scoreLevel, nextScoreLevel, competition,
      t, formatNumber
    } = this.props;
    return (
      <div id="dashboard">
        <div className="cc__page__column_content">
          <div
            className={'cc__page__column_content__left ' + this.getActiveClass(MobileSection.STATS | MobileSection.ACCOUNT)}
          >
            <div className={this.getActiveClass(MobileSection.ACCOUNT)}>
              <UserHeader
                user={user}
                competition={competition}
                university={university}
                healthFacility={healthFacility}
                competitionConfig={(competition && competition.config) || {}}
                team={team}
              />
              {score &&
                <UserStats
                  score={score}
                  footprint={competitionUser.footprint}
                  footprintPublic={competitionUser.footprintPublic !== false}
                  canManageFootprint={true}
                  onHideFootprint={this.props.hideFootprintFromProfile}
                  onRestoreFootprint={this.props.showFootprintOnProfile}
                  pledgeCompletions={pledgeCompletions}
                  scoreLevel={scoreLevel}
                  nextScoreLevel={nextScoreLevel}
                />
              }
            </div>
            <div className={'cc__white_box ' + this.getActiveClass(MobileSection.STATS)}>
              <Scoreboard />
            </div>
            {/*{university && <CampusRanks />  This gets rid of the 'Campus Ranking' on dashboard.*/}
            <div className={this.getActiveClass(MobileSection.ACCOUNT)}>
              {competitionUser.verified && <EarnMorePoints />}
            </div>
            <Footer />
          </div>
          <div role="main" className={'cc__page__column_content__right ' + this.getActiveClass(MobileSection.STORIES)}>
            {score &&
              <div className="cc__dashboard__mobile_points" aria-label={t('Points')}>
                <div className="cc__dashboard__mobile_points__item">
                  <div className="cc__stats__label">{t('Points')}</div>
                  <div className="cc__lighttext">{formatNumber(score.points, 0)}</div>
                </div>
                {scoreLevel &&
                  <div className="cc__dashboard__mobile_points__item">
                    <div className="cc__stats__label">{t('Level')}</div>
                    <div className="cc__lighttext">{scoreLevel.name}</div>
                  </div>
                }
              </div>
            }
            <PledgeCarousel />
            <Stories />
          </div>
        </div>
        <div className="cc__dashboard__bottom_menu">
          <div role="button" className="cc__dashboard__bottom_menu__account" onClick={() => this.selectSection(MobileSection.STORIES)}>
            <img
              alt={'activity'}
              src={this.getSrc(MobileSection.STORIES, 'activity')}
              srcSet={this.getSrcSet(MobileSection.STORIES, 'activity')} />
          </div>
          <div role="button" className="cc__dashboard__bottom_menu__stories" onClick={() => this.selectSection(MobileSection.ACCOUNT)}>
            <img
              alt={'profile'}
              src={this.getSrc(MobileSection.ACCOUNT, 'profile')}
              srcSet={this.getSrcSet(MobileSection.ACCOUNT, 'profile')} />
          </div>
          <div role="button" className="cc__dashboard__bottom_menu__statistics" onClick={() => this.selectSection(MobileSection.STATS)}>
            <img
              alt={'scoreboard'}
              src={this.getSrc(MobileSection.STATS, 'scoreboard')}
              srcSet={this.getSrcSet(MobileSection.STATS, 'scoreboard')} />
          </div>
        </div>
      </div>
    );
  }

  private selectSection(index: number) {
    this.setState({
      mobileSection: index
    });
  }

  private getActiveClass(index: number) {
    return (index & this.state.mobileSection) === this.state.mobileSection ? 'cc__mobile_show' : 'cc__mobile_hide';
  }

  private getSrc(index: number, image: string) {
    const selected = index === this.state.mobileSection ? '-selected' : '';
    return `/assets/dashboard/mobile/${image}${selected}.png`;
  }

  private getSrcSet(index: number, image: string) {
    const selected = index === this.state.mobileSection ? '-selected' : '';
    return `/assets/dashboard/mobile/${image}${selected}@2x.png 2x,
            /assets/dashboard/mobile/${image}${selected}@3x.png 3x`;
  }
}

const mapStateToProps = (state: State, _ownProps: Props): Partial<Props> => ({
  university: selectors.userUniversity(state),
  healthFacility: selectors.userHealthFacility(state),
  team: selectors.userTeam(state),
  user: state.user,
  competitionUser: state.competitionUser,
  competition: state.competition,
  score: getCompetitionUserScore(state.competitionUserScores, state.user && state.user.id),
  scoreLevel: selectors.userScoreLevel(state),
  nextScoreLevel: selectors.nextUserScoreLevel(state),
  userUniversityRank: selectors.userUniversityRank(state),
  pledgeCompletions: selectors.userTotalPledges(state),
  hasEmailPermittedByCompetition: selectors.hasEmailPermittedByCompetition(state)
});
const mapDispatchToProps = (dispatch: Dispatch): Partial<Props> => bindActionCreators({
  reinitializeDashboardIfNecessary: actions.reinitializeDashboardIfNecessary,
  hideFootprintFromProfile: actions.hideFootprintFromProfile,
  showFootprintOnProfile: actions.showFootprintOnProfile
}, dispatch);

export default asPage({ isGrey: true, requiresCompetitionStart: true, requiresCompetitionVerification: true })(compose(
  withLocalization('dashboard'),
  connect(mapStateToProps, mapDispatchToProps)
)(Dashboard));
